
import { useEffect, useState } from 'react';
import { Card, Row, Col, Form, Button, Table } from 'react-bootstrap';
import { faPenToSquare, faTrashCan  } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import NewUserModal from '../NewUserModal/NewUserModal';
import EditUserModal from '../EditUserModal/EditUserModal';
import Swal from "sweetalert2";
import NewModelModal from '../NewModelModal/NewModelModal';
import NewSerialModal from '../NewSerialModal/NewSerialModal';
import { useLocation } from "react-router-dom";
import EditSerialModal from '../EditSerialModal/EditSerialModal';


const EquipmentsMainTable = () => {


    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;
    const servicesURL = process.env.REACT_APP_SERVICES_API_URL;
    const backendAPI_Key = process.env.REACT_APP_API_KEY;

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const clientID = queryParams.get("clientID");
    const clientName = queryParams.get("clientName");

    //SESSION OBJECT
    const sessionUser = JSON.parse(sessionStorage.getItem("userSession"));
    const [serialListing, setSerialListing] = useState([]);


    //ADD NEW MODAL CONTROLLER
    const [showModal_AddModel, setShowModal_AddModel] = useState(false);   
    const requestCloseModal_AddModel = () => { setShowModal_AddModel(false); }
    const openModal_AddModel = () => { setShowModal_AddModel(true); }


    //ADD NEW MODAL CONTROLLER
    const [showModal_AddSerial, setShowModal_AddSerial] = useState(false);   
    const requestCloseModal_AddSerial = () => { setShowModal_AddSerial(false); }
    const openModal_AddSerial = () => { setShowModal_AddSerial(true); }



    //EDIT MODAL
    const [showModal_EditSerial, setShowModal_EditSerial] = useState(false);   
    const requestCloseModal_EditSerial = () => { setShowModal_EditSerial(false); }
    
    const [originalModel, setOriginalModel] = useState(false);
    const [originalSerial, setOriginalSerial] = useState(false);
    const [originalLocation, setOriginalLocation] = useState(false);

    const openEditModal = (modelo, serial, ubicacion) => {

        setOriginalModel(modelo);
        setOriginalSerial(serial);
        setOriginalLocation(ubicacion);
        setShowModal_EditSerial(true);

    } //END METHOD


    const getSerialsByClient = async () => {

        const endpoint = "getserialsbyclient?clienteId=" + clientID;

        const response = await fetch(servicesURL + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key}
        });

        const responseContent = await response.json();
        
        setSerialListing(responseContent);

    } //END FUNCTION


    const deleteSerial = async (serialNumber) =>{


        Swal.fire({
                title: '¿Estás seguro?',
                text: "Esta acción borrará el equipo seleccionado.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'

            }).then((result) => {


                if (result.isConfirmed) {
                    const endpoint = "eliminarSerial?clienteId=" + clientID + "&serial=" + serialNumber;
                    
                    fetch(servicesURL + endpoint,
                    {
                        method: "POST",
                        headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key}
                    }).then((response)=>{

                         //Show message sweet alert
                        Swal.fire({
                            title: "¡Éxito!",
                            text: "Operación realizada exitosamente.",
                            icon: "success",
                            confirmButtonText: "OK"
                        }).then((result) => {
                        if (result.isConfirmed) {
                            window.location.reload();
                        }});

                    });
                } //END IF
            });

    } //END FUNCTION

    

    useEffect(()=>{ 

        //
        if(!sessionUser || sessionUser.groupname != "Administrativos") {   
            window.location.href = "/"; 
        }

       
        //
        getSerialsByClient();

        
    }, []);



    return (

        <div style={{paddingLeft: "20px", paddingRight: "20px"}}>

            {/* SEARCH BOXES */}
            <Card variant="primary">
                <Card.Header style={{backgroundColor: "#404661", color: "white"}}>Listado de equipos por cliente</Card.Header>
                <Card.Body>

                    <Row>
                        <Col xs={12} md={4}>
                            <Form.Label className='subTitle_1' style={{color: "#828282"}}>Cliente</Form.Label><br />
                            <span style={{fontSize: "20px"}}>🏢 {clientName}</span>
                        </Col>
                   
                    </Row>
                </Card.Body>
            </Card>
            <hr />

            {/* USER TABLE */}
            <Row style={{paddingLeft: "20px", paddingRight: "20px"}}>

                <Col xs={12} style={{textAlign:"right"}}>
                    <Button 
                        variant="outline-primary"
                        size="sm"
                        style={{width: "220px", marginLeft:"10px" }}
                        onClick = {openModal_AddModel}
                    >
                        Agregar / Eliminar Modelo <span style={{fontSize: "18px"}}>🖨️</span>
                    </Button>
                    <Button 
                        variant="outline-primary"
                        size="sm"
                        style={{width: "220px", marginLeft:"10px" }}
                        onClick = {openModal_AddSerial}
                    >
                        Agregar Serial <span style={{fontSize: "18px"}}>🏷️</span>
                    </Button>
                </Col>
              
                <Col xs={12}>
                <hr />
                <Table striped className="mainTable">
                    <thead>
                        <tr>
                            <th>Modelo</th>
                            <th>Serial</th>
                            <th>Ubicación</th>
                            <th style={{textAlign:"center"}}>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>

                     

                        {serialListing.length > 0 && serialListing.map((item)=>{

                          
                            return (


                                <tr key={item.serial}>
                                    <td>{item.modelo}</td>
                                    <td>{item.serial}</td>
                                    <td>{item.ubicacion}</td>


                                    <td style={{textAlign:"center"}}>

                                        <FontAwesomeIcon icon={faPenToSquare} 
                                        style={{paddingLeft:"20px", color: "black", cursor:"pointer"}} title='Editar Usuario' onClick={()=> {openEditModal(item.modelo, item.serial, item.ubicacion);}} />

                                        <FontAwesomeIcon icon={faTrashCan} 
                                        style={{paddingLeft:"20px", color: "darkred", cursor:"pointer"}} title='Eliminar Equipo' onClick={()=> {deleteSerial(item.serial)}} />

                                    </td>
                                </tr>
                            )


                        })}
                    </tbody>
                </Table>
                </Col>
            </Row>


            {/* MODAL */}
            <NewModelModal show={showModal_AddModel} requestClose={requestCloseModal_AddModel}/>

            {/* MODAL */}
            <NewSerialModal show={showModal_AddSerial} requestClose={requestCloseModal_AddSerial}/>

            {/* MODAL */}
            <EditSerialModal show={showModal_EditSerial} requestClose={requestCloseModal_EditSerial} modelo={originalModel} serial={originalSerial} ubicacion={originalLocation} />



        </div>
    );

} //end



export default EquipmentsMainTable;
